import { render } from "./MasterBreadCrumb.vue?vue&type=template&id=2f6dd520&scoped=true"
import script from "./MasterBreadCrumb.vue?vue&type=script&lang=js"
export * from "./MasterBreadCrumb.vue?vue&type=script&lang=js"

import "./MasterBreadCrumb.vue?vue&type=style&index=0&id=2f6dd520&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6dd520"]])

export default __exports__